import {EmailAttachment} from './EmailAttachment';
import {BaseObject} from './BaseObject';

export class Email extends BaseObject {
    recipient = '';
    sender = '';
    message = '';
    subject = '';
    contracts: number[] = [];
    documents: number[] = [];
    attachments: EmailAttachment[] = [];
}



// WEBPACK FOOTER //
// /app/src/model/Entities/Email.ts